import * as Models from "../.";
export interface IPaymentProfile {
  creditCard: Models.PaymentCapture.CreditCardPaymentProfile.ICreditCardPaymentProfile;
  ach: Models.PaymentCapture.AchPaymentProfile.IAchPaymentProfile;
  bypassPayment: boolean;
}

export class PaymentProfile implements IPaymentProfile {
  creditCard: Models.PaymentCapture.CreditCardPaymentProfile.CreditCardPaymentProfile;
  ach: Models.PaymentCapture.AchPaymentProfile.AchPaymentProfile;
  bypassPayment: boolean;
}
